<template>
  <el-table-column
    prop="source_storage_name"
    sortable="custom"
    label="Szállító raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.source_storage_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'storage.name',
  };
</script>
